import { getMoneyValue } from '@/framework/directive/index.js'
import { CATEGORY_CODE_MAP, FEE_CODE_MAP } from '@/store/dict/rentPlanDict.js'


/*
  收款项
  1   租金
  2   押金
  3   管理费
  4   服务费
  13  定金
  14  滞纳金
  15  全款
  16  保证金
  24  首付款
  25  尾款
  100 其他
*/

// 不同费项收款方式下拉列表
export const paymentMethodsList = [
  {
    code: FEE_CODE_MAP.ZU_JIN,
    list: [
      {
        value: 3,
        label: '周付(满周)',
      },
      {
        value: 4,
        label: '月付（满月）',
      },
      {
        value: 5,
        label: '月付（自然月）',
      },
      {
        value: 10,
        label: '日付',
      },
      {
        value: 6,
        label: '一次性',
      },
    ],
  },
  {
    code: FEE_CODE_MAP.YA_JIN,
    list: [
      {
        value: 6,
        label: '一次性',
      },
      {
        value: 11,
        label: '分期',
      },
    ],
  },
  {
    code: FEE_CODE_MAP.GUAN_LI_FEE,
    list: [
      {
        value: 3,
        label: '周付(满周)',
      },
      {
        value: 4,
        label: '月付（满月）',
      },
      {
        value: 5,
        label: '月付（自然月）',
      },
      {
        value: 10,
        label: '日付',
      },
    ],
  },
  {
    code: FEE_CODE_MAP.FU_WU_FEE,
    list: [
      {
        value: 3,
        label: '周付(满周)',
      },
      {
        value: 4,
        label: '月付（满月）',
      },
      {
        value: 5,
        label: '月付（自然月）',
      },
      {
        value: 10,
        label: '日付',
      },
    ],
  },
  {
    code: FEE_CODE_MAP.DING_JIN,
    list: [
      {
        value: 6,
        label: '一次性',
      },
    ],
  },
  {
    code: FEE_CODE_MAP.ZHI_NA_JIN,
    list: [
      {
        value: 6,
        label: '一次性',
      },
    ],
  },
  {
    code: FEE_CODE_MAP.QUAN_KUAN,
    list: [
      {
        value: 6,
        label: '一次性',
      },
    ],
  },
  {
    code: FEE_CODE_MAP.BAO_ZHENG_JIN,
    list: [
      {
        value: 6,
        label: '一次性',
      },
    ],
  },
  {
    code: FEE_CODE_MAP.SHOU_FU_KUAN,
    list: [
      {
        value: 6,
        label: '一次性',
      },
    ],
  },
  {
    code: FEE_CODE_MAP.WEI_KUAN,
    list: [
      {
        value: 6,
        label: '一次性',
      },
    ],
  },
  {
    code: FEE_CODE_MAP.OTHERS,
    list: [
      {
        value: 3,
        label: '周付(满周)',
      },
      {
        value: 4,
        label: '月付（满月）',
      },
      {
        value: 5,
        label: '月付（自然月）',
      },
      {
        value: 6,
        label: '一次性',
      },
    ],
  },
]

export const DEPOSIT_COLLECT_RULE = {
  ONCE: 1,
  CUSTOM_STAGES: 2,
  FOLLOW_RENT: 3,
}

export const DEPOSIT_COLLECT_RULE_TEXT = {
  [DEPOSIT_COLLECT_RULE.ONCE]: '一次收清',
  [DEPOSIT_COLLECT_RULE.CUSTOM_STAGES]: '自定义分期收款',
  [DEPOSIT_COLLECT_RULE.FOLLOW_RENT]: '随租金周期收取',
}

// 根据收款项展示不同表单项
export const formItemList = [
  {
    code: FEE_CODE_MAP.ZU_JIN,
    name: '租金',
    showFormItem: [
      // 收款方式
      'payMode',
      // 收款金额
      'amount',
      // 收款金额保留位数
      'amountAccuracy',
    ],
  },
  {
    code: FEE_CODE_MAP.YA_JIN,
    name: '押金',
    showFormItem: [
      // 收款方式
      'payMode',
      // 收款金额
      'amount',
    ],
  },
  {
    code: FEE_CODE_MAP.GUAN_LI_FEE,
    name: '管理费',
    showFormItem: [
      // 收款方式
      'payMode',
      // 收款金额
      'amount',
    ],
  },
  {
    code: FEE_CODE_MAP.FU_WU_FEE,
    name: '服务费',
    showFormItem: [
      // 收款方式
      'payMode',
      // 收款金额
      'amount',
    ],
  },
  {
    code: FEE_CODE_MAP.SHOU_FU_KUAN,
    name: '首付款',
    showFormItem: [
      // 收款方式
      'payMode',
      // 收款金额
      'amount',
    ],
  },
  {
    code: FEE_CODE_MAP.QUAN_KUAN,
    name: '全款',
    showFormItem: [
      // 收款方式
      'payMode',
      // 收款金额
      'amount',
    ],
  },
  {
    code: FEE_CODE_MAP.WEI_KUAN,
    name: '尾款',
    showFormItem: [
      // 收款方式
      'payMode',
      // 收款金额
      'amount',
    ],
  },
]
function validatorInterestFreeDays(rule, value, callback) {
  if (rule.required === true) {
    if (value === '') {
      return callback(new Error('请输入滞纳金免息天数'))
    }
  }
  const min = 0
  const max = 365
  if ((!isNaN(value) && (value >= min && value <= max)) || value === '') {
    return callback()
  }
  callback(new Error('请输入0-365之间的数字'))
}

export const configRules = {
  depositCollectRule: [
    {
      required: true,
      message: '请选择押金收取规则',
      trigger: ['change'],
    },
  ],
  payMode: [
    {
      required: true,
      message: '请选择收款方式',
      trigger: ['blur'],
    },
  ],
  amount: [
    {
      required: false,
      message: '收款金额不能为空',
    },
  ],
  depositCustomPeriods: [
    {
      required: true,
      message: '请选择期数',
      trigger: ['change'],
    },
  ],
  depositPeriodAmount: [
    {
      required: true,
      message: '请输入每期押金',
      trigger: ['blur', 'change'],
    },
  ],
  payPlanType: [
    {
      required: true,
      message: '请选择租金类型',
      trigger: ['blur'],
    },
  ],
  amountAccuracy: [
    {
      required: true,
      message: '请选择收款金额保留位数',
      trigger: ['blur'],
    },
  ],
  lateFeeProportion: [
    {
      required: true,
      message: '请输入滞纳金收取比例',
      trigger: ['blur'],
    },
  ],
  interestFreeDays: [
    {
      required: true,
      validator: validatorInterestFreeDays.bind(this),
      trigger: ['blur'],
    },
  ],
  spId: [
    {
      required: true,
      message: '请选择完单平台',
      trigger: ['change'],
    },
  ],
  dynamicType: [
    {
      required: true,
      message: '请选择动态条件',
    },
  ],
  dynamicList: [
    {
      required: true,
      message: '请填写租金规则',
    },
  ],
  advancePayment: [
    {
      required: true,
      message: '请选择提车时需缴纳方式',
      trigger: ['change'],
    },
  ],
}

// 场景
export const SCENE_TYPE = {
  LEASE_PLAN: 'leasePlan',
  SIGN_CONTRACT: 'signContract',
}

// 校验信息
export const CHECK_CONF = {
  // 租赁方案
  [SCENE_TYPE.LEASE_PLAN]: {
    // 创建场景校验提示
    add: {
      rentPeriod: {
        message: (rentInfo) => {
          return rentInfo.isEndDateMode ? '请先选择“租赁结束日”' : '请先填写“租期”'
        },
        validate: (rentInfo) => {
          if (rentInfo.isEndDateMode) {
            return !rentInfo.endDate
          }
          return !rentInfo.rentPeriod || Number(rentInfo.rentPeriod) === 0
        },
      },
      payMode: {
        message: (rentInfo) => (rentInfo.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI ? '请先选择“结算周期”' : '请先选择“收款方式”'),
        validate: (rentInfo) => {
          return !rentInfo.payMode
        },
      },
    },
    // 编辑场景校验提示
    edit: {
      rentPeriod: {
        message: (rentInfo) => {
          return rentInfo.isEndDateMode ? '请先选择“租赁结束日”' : '请先填写“租期”'
        },
        validate: (rentInfo) => {
          if (rentInfo.isEndDateMode) {
            return !rentInfo.endDate
          }
          return !rentInfo.rentPeriod || Number(rentInfo.rentPeriod) === 0
        },
      },
      payMode: {
        message: (rentInfo) => (rentInfo.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI ? '请先选择“结算周期”' : '请先选择“收款方式”'),
        validate: (rentInfo) => {
          return !rentInfo.payMode
        },
      },
    },
    // 数据处理方法名
    handleData: 'getLeasePlanData',
  },
  // 个人签约
  [SCENE_TYPE.SIGN_CONTRACT]: {
    add: {
      rentPeriod: {
        message: (rentInfo) => {
          return rentInfo.isEndDateMode ? '请先选择“租赁结束日”' : '请先填写“租期”'
        },
        validate: (rentInfo) => {
          if (rentInfo.isEndDateMode) {
            return !rentInfo.endDate
          }
          return !rentInfo.rentPeriod
        },
      },
      payMode: {
        message: (rentInfo) => (rentInfo.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI ? '请先选择“结算周期”' : '请先选择“收款方式”'),
        validate: (rentInfo) => {
          return !rentInfo.payMode
        },
      },
      startStopDate: {
        message: () => { return '请先选择“租赁起始日”' },
        validate: (rentInfo) => {
          return Array.isArray(rentInfo.startStopDate) && rentInfo.startStopDate.length === 0
        },
      },
    },
    edit: {
      rentPeriod: {
        message: (rentInfo) => {
          return rentInfo.isEndDateMode ? '请先选择“租赁结束日”' : '请先填写“租期”'
        },
        validate: (rentInfo) => {
          if (rentInfo.isEndDateMode) {
            return !rentInfo.endDate
          }
          return !rentInfo.rentPeriod
        },
      },
      payMode: {
        message: (rentInfo) => (rentInfo.rentCategory === CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI ? '请先选择“结算周期”' : '请先选择“收款方式”'),
        validate: (rentInfo) => {
          return !rentInfo.payMode
        },
      },
      startStopDate: {
        message: () => { return '请先选择“租赁起始日”' },
        validate: (rentInfo) => {
          return Array.isArray(rentInfo.startStopDate) && rentInfo.startStopDate.length === 0
        },
      },
    },
    handleData: 'getSignContractData',
  },
}

export function rentInfoFn() {
  const rentInfo_formConfig = [
    {
      el: 'select',
      itemConfig: {
        label: '类别:',
        prop: 'rentCategory',
      },
      elConfig: {
        disabled: this.disabled,
        clearable: false,
        events: {
          change: () => {
            this.queryFeeList().then((feeList) => this.addRequiredFee(feeList, 'fromEvent'))
          },
        },
        options: { // 下拉数据
          label: 'name',
          value: 'code',
          list: this.categoryFilterList,
        },
      },
    },
    {
      el: 'date-picker',
      itemConfig: {
        label: '签署日期:',
        prop: 'signDate',
      },
      elConfig: {
        clearable: false,
        type: 'date',
        placeholder: '选择签署日期',
        pickerOptions: this.signInfoScrapDate,
      },
    },
    {
      el: 'date-picker',
      itemConfig: {
        label: '收款起止日期:',
        prop: 'startStopDate',
        ref: 'startStopDate',
      },
      elConfig: {
        pickerOptions: this.startStopInfoScrapDate,
        defaultValue: this.availablePaymentStartDate,
        events: {
          change: this.startStopDateChange,
        },
      },
    },
    {
      el: 'input',
      itemConfig: {
        label: '赠送天数',
        prop: 'presentDays',
      },
      render: () => {
        const h = this.$createElement
        return h('el-form-item', {
          props: {
            prop: 'presentDays',
            label: '赠送天数:',
          },
        }, [
          h('el-input', {
            attrs: {
              disabled: this.disabled,
              placeholder: '请输入0~365之间的数字',
              maxlength: 3,
              style: 'width: 185px;', // 添加宽度属性
            },
            props: {
              value: this.rentInfo_model.presentDays,
            },
            on: {
              input: (value) => {
                const val = value.replace(/[^\d]/g, '')
                const days = getMoneyValue(val) > 365 ? 365 : getMoneyValue(val)
                this.rentInfo_model.presentDays = days
                this.calculateContractDate()
              },
            },
          }, [
            h('template', { slot: 'append' }, '天'),
          ]),
        ])
      },
    },
  ]
  if (this.showDeposit) {
    rentInfo_formConfig.push({
      el: 'radio',
      itemConfig: {
        label: `是否平移原订单押金\n\r（已收押金：${Math.max(this.deposit.depositReceived, 0.00)}元）:`,
        prop: 'isTranDeposit',
        labelTip: {
          content: '勾选是：<br />1）押金会在原订单合同截止时将押金平移至新订单<br />2）新订单押金应收金额等于原订单应收押金金额<br />3）如在平移时押金仍有押金欠款，会在新订单继续要求司机补缴欠款<br />勾选否(原订单未收取押金或押金目前有在途单据时不可平移)：<br />1）原订单押金不会平移到新订单，需在原订单合同结束时结算并退款给司机<br />2）新订单需重新配置并收取押金',
        },
        disabled: !this.deposit.flag,
        'label-width': '300px',
        class: 'tran-deposit-radio',
      },
      elConfig: {
        options: { // 下拉数据
          label: 'label',
          value: 'value',
          list: [
            { label: '是', value: 1 },
            { label: '否', value: 0 },
          ],
        },
        events: {
          change: () => {
            this.queryFeeList().then((feeList) => this.addRequiredFee(feeList, 'fromEvent'))
          },
        },
      },
    })
  }
  const rentInfo_model = {
    rentCategory: CATEGORY_CODE_MAP.ZU_CHE, // 类别，默认租车
    signDate: new Date(), // 签署日期
    startStopDate: '', // 收款起止日期
    presentDays: null, // 赠送天数
    isTranDeposit: '', // 是否平移原订单押金 1-是 0-否
    contractDateText: '', // 合同起止日期文本 eg: 2023-07-01~2023-07-31 —————— 需在其他组件展示，未在当前组件绑定
    rentPeriodText: '', // 租期文本(天数) eg: 共7天 —————— 需在其他组件展示，未在当前组件绑定
    presentDaysText: '', // 赠送天数文本 eg: 0天 —————— 需在其他组件展示，未在当前组件绑定
    disabled: false, // 禁用 - 若是选择租赁方案，会置位true，此字段会传到组件 rentLeasePlanInfo 中，禁用新增费项按钮
    allTotalAmount: '', // 总金额
    deposit: '', // 押金
    rentAmount: '', // 租金
    firstPayment: '', // 首付款
    fullPayment: '', // 全款
    otherAmount: '', // 其余收款项
  }
  const rentInfo_formRule = {
    rentCategory: [
      {
        required: true,
        message: '类别不能为空',
        trigger: 'change',
      },
    ],
    signDate: [
      {
        required: true,
        message: '请选择签署日期',
        trigger: 'change',
      },
    ],
    startStopDate: [
      {
        required: true,
        message: '请选择收款起止日期',
        trigger: 'change',
      },
    ],
    isTranDeposit: [
      {
        required: true,
        message: '请选择',
        trigger: 'change',
      },
    ],
  }
  return {
    rentInfo_formConfig,
    rentInfo_model,
    rentInfo_formRule,
  }
}

// 租金类型
export const RENT_TYPE = {
  FIXEDRENT: 0, // 固定租金
  DYNAMICRENT: 2, // 动态租金
}

export const DYNAMIC_TYPE = {
  OVER_ORDER_NUM: 1, // 完单量
}

export const DYNAMIC_TYPE_TEXT = {
  [DYNAMIC_TYPE.OVER_ORDER_NUM]: '账单周期内完单量',
}

// 提车时需缴纳枚举值
export const ADVANCE_PAYMENT_CODE = {
  ALL: 2, // 全部费用
  FIRST_PERIOD: 1, // 首期费用
  NO_PAYMENT: 0, // 无需缴纳
}
export const ADVANCE_PAYMENT_LIST = {
  [ADVANCE_PAYMENT_CODE.ALL]: '全部费用',
  [ADVANCE_PAYMENT_CODE.FIRST_PERIOD]: '首期费用',
  [ADVANCE_PAYMENT_CODE.NO_PAYMENT]: '无需缴纳费用',
}
